export const myProfilePages = {
  profile: () => import('./pages/MyProfilePage'),
};
